import type { RefObject } from 'react';
import type {
  HeaderNotificationItem,
  HeaderNotificationSource,
  NotificationPreference,
} from './notification-types';
import { NotificationFeed } from './notification-feed';
import { NotificationPreferences } from './notification-preferences';

export type NotificationPanelView = 'feed' | 'preferences';

type NotificationPanelProps = {
  view: NotificationPanelView;
  items: HeaderNotificationItem[];
  groups?: { id: string; name: string }[];
  source?: HeaderNotificationSource;
  scrollRootRef: RefObject<HTMLDivElement | null>;
  preferences: NotificationPreference[];
  preferenceValues: Record<NotificationPreference['id'], boolean>;
  isMobile: boolean;
  onMarkAllAsRead: () => void;
  onOpenPreferences: () => void;
  onSelectNotification: (item: HeaderNotificationItem) => void;
  onBack: () => void;
  onPreferenceChange: (
    id: NotificationPreference['id'],
    value: boolean
  ) => void;
};

export function NotificationPanel({
  view,
  items,
  groups,
  source,
  scrollRootRef,
  preferences,
  preferenceValues,
  isMobile,
  onMarkAllAsRead,
  onOpenPreferences,
  onSelectNotification,
  onBack,
  onPreferenceChange,
}: NotificationPanelProps) {
  if (view === 'preferences') {
    return (
      <NotificationPreferences
        preferences={preferences}
        values={preferenceValues}
        isLoading={source?.isPreferencesLoading ?? false}
        error={source?.preferenceError ?? null}
        updatingPreferenceId={source?.updatingPreferenceId ?? null}
        isMobile={isMobile}
        onBack={onBack}
        onRetry={source?.onLoadPreferences ?? (() => undefined)}
        onValueChange={onPreferenceChange}
      />
    );
  }

  return (
    <NotificationFeed
      items={items}
      groups={groups}
      source={source}
      scrollRootRef={scrollRootRef}
      isMobile={isMobile}
      onMarkAllAsRead={onMarkAllAsRead}
      onOpenPreferences={onOpenPreferences}
      onSelectNotification={onSelectNotification}
    />
  );
}
